import { Wrapper } from 'components/ui';
import useI18n from 'hooks/I18n/useI18n';
import React from 'react';
import PropTypes from 'prop-types';
import UserRegistrationForm from './UserRegistrationForm.jsx';
import TermsPublicFooter from 'components/TermsPublicFooter.jsx';

const UserRegistration = ({ role, ...rest }) => {
    const { trans } = useI18n();
    let introductionText = false;

    if (role === 'farm') {
        introductionText = trans('session.producerIntro');
    } else if (role === 'host') {
        introductionText = trans('session.hostIntro');
    }

    return (
        <Wrapper xsPadding margin="bottom">
            <div className="createAccount row">
                <div className="initialCenteredBox col-sm-8 col-md-6">
                    {introductionText && (
                        <div
                            className="introductionText"
                            dangerouslySetInnerHTML={{ __html: introductionText }}
                        />
                    )}
                    <UserRegistrationForm {...rest} role={role} />
                </div>
            </div>
            <TermsPublicFooter />
        </Wrapper>
    );
};

UserRegistration.propTypes = {
    role: PropTypes.string,
};

export default UserRegistration;
